(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-section"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var button = event.target.closest('.riot-collective-signup');
    if (!button) return;
    var formId = window.matchMedia('(max-width: 767px)').matches
      ? button.dataset.klaviyoMobile
      : button.dataset.klaviyoDesktop;
    if (!formId) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["riot-accessibility-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.riotNavigationAccessibility) return;
  window.riotNavigationAccessibility = true;
  let scheduled = false;
  function sync() {
    scheduled = false;
    document.querySelectorAll('a.site-nav__link--has-dropdown').forEach((link, index) => {
      const dropdown = link.parentElement.querySelector('.site-nav__dropdown');
      if (!dropdown) return;
      if (!dropdown.id) dropdown.id = 'riot-nav-dropdown-' + index;
      link.setAttribute('aria-controls', dropdown.id);
      link.setAttribute('aria-haspopup', 'true');
      const style = getComputedStyle(dropdown);
      const expanded = String(style.visibility !== 'hidden' && style.display !== 'none' && dropdown.getClientRects().length > 0);
      if (link.getAttribute('aria-expanded') !== expanded) link.setAttribute('aria-expanded', expanded);
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  ['pointerover','pointerout','focusin','focusout','transitionend'].forEach(event => document.addEventListener(event, schedule, true));
  document.addEventListener('keydown', event => {
    const link = event.target.closest('a.site-nav__link--has-dropdown');
    if (link && event.key === 'ArrowDown') {
      event.preventDefault();
      link.parentElement.classList.add('is-focused');
      const firstLink = link.parentElement.querySelector('.site-nav__dropdown a');
      if (firstLink) firstLink.focus();
      schedule();
    }
    const item = event.target.closest('.site-nav--has-dropdown');
    if (item && event.key === 'Escape') {
      event.preventDefault();
      item.querySelector('a.site-nav__link--has-dropdown')?.focus();
      item.classList.remove('is-focused');
      schedule();
    }
  });
  window.addEventListener('resize', schedule);
  const header = document.getElementById('HeaderWrapper');
  if (header) new MutationObserver(schedule).observe(header, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style']});
  sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["riot-quick-shop"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.riotQuickShopInstalled) return;
  window.riotQuickShopInstalled = true;
  const loading = new WeakSet();
  const mobileQuickShop = window.matchMedia('(max-width: 769px)');
  mobileQuickShop.addEventListener('change', scan);
  function updatePreorderNotes() {
    document.querySelectorAll('[data-riot-selected-preorder-note]').forEach(note => {
      const form = note.closest('[data-product-blocks]')?.querySelector('form[action*="/cart/add"]');
      const plan = form && new FormData(form).get('selling_plan');
      const blocks = note.closest('[data-product-blocks]');
      const ids = (note.dataset.riotPreorderIds || '').split(',').map(id => id.trim()).filter(Boolean);
      const app = window.Globo?.Preorder;
      const product = form && app && appProduct(app, form);
      const selected = blocks?.querySelector('[data-riot-size-variant-id]:checked');
      const variantId = selected?.dataset.riotSizeVariantId || form?.querySelector('[name="id"]')?.value;
      let actualPreorder = false;
      if (product && variantId && app.getResolvedProfile) {
        try { actualPreorder = app.getResolvedProfile(product, variantId)?.isPreorder === true; }
        catch (_) {}
      }
      const nativePreorder = blocks?.dataset.riotSelectedPreorder === 'true';
      note.hidden = !(actualPreorder && (nativePreorder || (plan && ids.includes(String(plan)))));
    });
  }
  function schedulePreorderNotes() {
    updatePreorderNotes();
    setTimeout(updatePreorderNotes, 50);
    setTimeout(updatePreorderNotes, 250);
  }
  ['change', 'variant:change', 'globo.preorder.show.preorder',
   'globo.preorder.show.addtocart', 'globo.preorder.form.payment'].forEach(name =>
    document.addEventListener(name, schedulePreorderNotes));

  const preorderForms = new WeakMap();
  const wrappedForms = new WeakMap();
  const activeFormSelector = '[id^="QuickShopModal-"].modal--is-active form[action*="/cart/add"]';
  function isQuickForm(form) {
    return form && form.closest('[id^="QuickShopModal-"]');
  }
  function pending(form, value) {
    form.toggleAttribute('data-riot-preorder-pending', value);
    form.setAttribute('aria-busy', String(value));
  }
  function appProduct(app, form) {
    const section = form.closest('[data-product-id]');
    return app.settings.products?.find(product => String(product.id) === section?.dataset.productId);
  }
  function protectPreorderBlocks() {
    const app = window.Globo?.Preorder;
    document.querySelectorAll(activeFormSelector).forEach(form => {
      const blocks = form.closest('[data-product-blocks]');
      if (!blocks || blocks.dataset.riotPreorderPlan !== 'true') return;
      if (preorderForms.has(form)) return;
      pending(form, true);
      if (!app?.initCollectionQuickview || !appProduct(app, form)) return;
      if (!app.riotVisibleQuickViewSelector) {
        app.riotVisibleQuickViewSelector = true;
        app.settings.selectors.quickViewProductForm = activeFormSelector;
      }
      const modal = isQuickForm(form);
      const product = appProduct(app, form);
      modal.setAttribute('preorder-product-element', 'id');
      modal.setAttribute('d-id', product.id);
      preorderForms.set(form, true);
      app.initCollectionQuickview(form);
    });
  }
  function rendered(event) {
    const wrapped = event.detail?.form;
    const form = wrapped?.[0];
    if (!form) return;
    const productBlocks = form.closest('[data-product-blocks]');
    if (productBlocks) {
      productBlocks.dataset.riotSelectedPreorder = String(event.type === 'globo.preorder.show.preorder');
    }
    schedulePreorderNotes();
    updateSizeAvailability();
    setTimeout(updateSizeAvailability, 1100);
    if (!isQuickForm(form)) return;
    wrappedForms.set(form, wrapped);
    pending(form, false);
    const blocks = form.closest('[data-product-blocks]');
    blocks?.querySelectorAll('.riot-delivery-summary').forEach(summary => {
      summary.hidden = event.type !== 'globo.preorder.show.addtocart';
    });
  }
  ['globo.preorder.show.preorder', 'globo.preorder.show.addtocart',
   'globo.preorder.show.naMessage', 'globo.preorder.show.comingSoon',
   'globo.preorder.show.comingSoonAtc'].forEach(name => document.addEventListener(name, rendered));
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (!variant) return;
    document.querySelectorAll(activeFormSelector).forEach(form => {
      const wrapped = wrappedForms.get(form);
      const app = window.Globo?.Preorder;
      const product = app && appProduct(app, form);
      if (!wrapped || !product?.variants.some(item => String(item.id) === String(variant.id))) return;
      pending(form, true);
      setTimeout(() => {
        if (!form.isConnected) return;
        const selector = form.querySelector('[name="id"]');
        if (selector) selector.value = variant.id;
        const settings = app.settings.selectors;
        const addSelector = settings.productAddToCartBtn.find(item => form.querySelector(item));
        app.renderProductForm(product, wrapped, settings.productVariantActivator,
          settings.productVariantSelector, settings.productQuantitySelector,
          addSelector, settings.productAddToCartTextElement, settings.paymentButton);
      }, 20);
    });
  });
  document.addEventListener('submit', event => {
    if (!event.target.hasAttribute('data-riot-preorder-pending')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('click', event => {
    const form = event.target.closest('form[data-riot-preorder-pending]');
    if (!form || !event.target.closest('[name="add"], [type="submit"], .gPreorderBtn')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('modalOpen', () => setTimeout(scan, 30));
  const readinessPoll = setInterval(() => { protectPreorderBlocks(); updateSizeAvailability(); initializeKiwiCharts(); }, 300);
  setTimeout(() => clearInterval(readinessPoll), 60000);
  const kiwiLoaded = new WeakSet();
  const kiwiAttempts = new WeakMap();
  let kiwiScriptLoading = false;
  function initializeKiwiCharts() {
    const activeCharts = Array.from(document.querySelectorAll('[id^="QuickShopModal-"].modal--is-active [data-riot-kiwi-chart]'));
    const pageCharts = Array.from(document.querySelectorAll('[data-riot-kiwi-chart]')).filter(chart => !chart.closest('[id^="QuickShopModal-"]'));
    const charts = (activeCharts.length ? activeCharts : pageCharts).slice(0, 1);
    if (!charts.length) return;
    if (!window.ks?.loadSizing) {
      if (kiwiScriptLoading) return;
      kiwiScriptLoading = true;
      const script = document.createElement('script');
      script.src = 'https://app.kiwisizing.com/web/js/dist/kiwiSizing/plugin/SizingPlugin.prod.js?shop=' + encodeURIComponent(window.Shopify.shop);
      script.onload = () => { kiwiScriptLoading = false; initializeKiwiCharts(); };
      script.onerror = () => { kiwiScriptLoading = false; };
      document.head.appendChild(script);
      return;
    }
    window.ks.setShopID(window.Shopify.shop);
    document.querySelectorAll('[data-riot-kiwi-chart][id]').forEach(chart => {
      if (!charts.includes(chart)) chart.removeAttribute('id');
    });
    charts.forEach(chart => {
      chart.id = 'KiwiSizingChart';
      if (chart.childElementCount > 0) { kiwiLoaded.add(chart); return; }
      if (kiwiLoaded.has(chart)) return;
      const previous = kiwiAttempts.get(chart) || {count: 0, at: 0};
      if (previous.count >= 3 || Date.now() - previous.at < 3000) return;
      kiwiAttempts.set(chart, {count: previous.count + 1, at: Date.now()});
      try { window.ks.loadSizing({productData: {}, options: {}}); }
      catch (error) { console.warn('RIOT size guide could not initialize.', error); }
    });
  }
  function updateSizeAvailability() {
    const app = window.Globo?.Preorder;
    if (!app?.getResolvedProfile) return;
    document.querySelectorAll('[data-product-blocks]').forEach(blocks => {
      const form = blocks.querySelector('form[action*="/cart/add"]');
      const product = form && appProduct(app, form);
      if (!product) return;
      const inputs = Array.from(blocks.querySelectorAll('[data-riot-size-variant-id]'));
      if (!inputs.length) return;
      let hasPreorder = false;
      let hasStock = false;
      inputs.forEach(input => {
        const wrapper = input.closest('.variant-wrapper');
        const label = input.closest('.variant-input')?.querySelector('label');
        if (!label || !wrapper) return;
        let profile;
        try { profile = app.getResolvedProfile(product, input.dataset.riotSizeVariantId); }
        catch (error) { return; }
        const state = profile?.isPreorder ? 'preorder' :
          profile?.isComingSoon ? 'comingsoon' :
          input.dataset.riotSizeAvailable === 'true' ? 'stock' : 'soldout';
        hasPreorder = hasPreorder || state === 'preorder';
        hasStock = hasStock || state === 'stock';
        const text = wrapper.dataset['riot' + state.charAt(0).toUpperCase() + state.slice(1) + 'Word'];
        if (!text) return;
        let status = label.querySelector('[data-riot-size-status]');
        if (!status) {
          status = document.createElement('span');
          status.className = 'riot-size-availability';
          status.setAttribute('data-riot-size-status', '');
          label.appendChild(status);
        }
        if (status.textContent !== text) status.textContent = text;
      });
      blocks.querySelectorAll('[data-riot-size-status]').forEach(status => {
        status.hidden = !(hasPreorder && hasStock);
      });
      const hint = blocks.querySelector('[data-riot-size-availability-hint]');
      if (hint) hint.hidden = !(hasPreorder && hasStock);
      const selected = inputs.find(input => input.checked);
      const price = blocks.querySelector('.product-block--price');
      if (!price || !selected) return;
      const profile = app.getResolvedProfile(product, selected.dataset.riotSizeVariantId);
      const isPreorder = !!profile?.isPreorder;
      const nativeClass = app.settings.classes?.preorderLabel;
      const nativeLabel = nativeClass && /^[a-zA-Z0-9_-]+$/.test(nativeClass) ?
        price.querySelector('.' + nativeClass) : null;
      if (nativeLabel) {
        nativeLabel.setAttribute('data-riot-preorder-state', '');
        nativeLabel.hidden = !isPreorder;
      }
      let ownLabel = price.querySelector('[data-riot-selected-preorder-label]');
      if (!nativeLabel && isPreorder && !ownLabel) {
        ownLabel = document.createElement('span');
        ownLabel.className = 'riot-selected-preorder-label';
        ownLabel.setAttribute('data-riot-selected-preorder-label', '');
        price.appendChild(ownLabel);
      }
      if (ownLabel) ownLabel.hidden = !isPreorder || !!nativeLabel;
      const label = nativeLabel || ownLabel;
      if (label && isPreorder) {
        const text = selected.closest('.variant-wrapper').dataset.riotPreorderWord;
        if (label.textContent !== text) label.textContent = text;
        form.querySelectorAll('h1,h2,h3,h4,h5,h6,strong,p,div').forEach(heading => {
          const normalized = heading.textContent.replace(/[^a-z]/gi, '').toLowerCase();
          if (normalized === 'nowavailableforpreorder' && !heading.contains(label)) {
            heading.classList.add('riot-preorder-heading-hidden');
          }
        });
      }
    });
  }
  function removeDuplicateSizeGuides() {
    document.querySelectorAll('[data-product-blocks]').forEach(blocks => {
      const preferred = Array.from(blocks.querySelectorAll('[data-riot-kiwi-chart]')).find(chart =>
        Array.from(chart.querySelectorAll('a,button,[role="button"],div')).some(node =>
          node.textContent.trim() && node.getClientRects().length > 0));
      blocks.querySelectorAll('[data-riot-duplicate-size-guide]').forEach(node => {
        if (!preferred) node.removeAttribute('data-riot-duplicate-size-guide');
      });
      if (!preferred) return;
      const labels = new Set(['sizechart','sizeguide',
        (preferred.dataset.linkText || '').replace(/[^a-z]/gi, '').toLowerCase()]);
      blocks.querySelectorAll('a,button,[role="button"],div').forEach(node => {
        if (node.closest('[data-riot-kiwi-chart]') || node.contains(preferred)) return;
        if (node.closest('.ks-modal')) return;
        const text = node.textContent.replace(/[^a-z]/gi, '').toLowerCase();
        if (!text || !labels.has(text)) return;
        node.setAttribute('data-riot-duplicate-size-guide', '');
      });
    });
  }
  function scan() {
    document.querySelectorAll('.modal--quick-shop').forEach(modal => {
      const existing = document.getElementById(modal.id);
      if (existing && existing !== modal && existing.parentElement === document.body) {
        modal.remove();
        return;
      }
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      const links = Array.from(modal.querySelectorAll('.riot-quick-full-details'));
      links.slice(0, -1).forEach(link => link.remove());
      modal.querySelectorAll('[data-riot-selected-preorder-note]').forEach(note => {
        const form = note.closest('[data-product-blocks]')?.querySelector('form[action*="/cart/add"]');
        if (form && note.parentElement !== form) form.prepend(note);
      });
    });
    updateSizeAvailability();
    initializeKiwiCharts();
    removeDuplicateSizeGuides();
    protectPreorderBlocks();
    updatePreorderNotes();
    document.querySelectorAll('.quick-product__btn').forEach(trigger => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'dialog');
      const card = trigger.closest('.grid-product');
      const mask = card?.querySelector('.grid-product__image-mask');
      const content = card?.querySelector('.grid-product__content');
      if (mask && content) {
        if (mobileQuickShop.matches) {
          trigger.classList.add('riot-quick-shop-mobile');
          if (trigger.parentElement !== content) content.appendChild(trigger);
        } else {
          trigger.classList.remove('riot-quick-shop-mobile');
          if (trigger.parentElement !== mask) mask.prepend(trigger);
        }
      }
      if (card && card.dataset.productId) {
        const modalId = 'QuickShopModal-' + card.dataset.productId;
        trigger.setAttribute('aria-controls', modalId);
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.setAttribute('role', 'dialog');
          modal.setAttribute('aria-modal', 'true');
          const title = card.querySelector('.grid-product__title');
          if (title) modal.setAttribute('aria-label', title.textContent.trim());
        }
      }
    });
  }
  scan();
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) scan();
  }).observe(document.body, {childList:true, subtree:true});
  const activate = (event) => {
    const trigger = event.target.closest('.quick-product__btn');
    if (!trigger) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (!trigger.classList.contains('quick-product__btn--not-ready')) {
      if (event.type === 'keydown') {
        event.preventDefault();
        event.stopImmediatePropagation();
        trigger.click();
      }
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (loading.has(trigger)) return;
    const card = trigger.closest('.grid-product');
    if (!card || !card.dataset.productId || !card.dataset.productHandle) return;
    loading.add(trigger);
    trigger.setAttribute('aria-busy', 'true');
    const observer = new MutationObserver(() => {
      if (trigger.classList.contains('quick-product__btn--not-ready')) return;
      observer.disconnect();
      clearTimeout(timer);
      loading.delete(trigger);
      trigger.removeAttribute('aria-busy');
      trigger.click();
    });
    observer.observe(trigger, { attributes: true, attributeFilter: ['class'] });
    const timer = setTimeout(() => {
      observer.disconnect();
      loading.delete(trigger);
      trigger.removeAttribute('aria-busy');
      const link = card.querySelector('a[href*="/products/"]');
      if (link) location.assign(link.href);
    }, 8000);
    theme.preloadProductModal(card.dataset.productHandle, card.dataset.productId, trigger);
  };
  document.addEventListener('click', activate, true);
  document.addEventListener('keydown', activate, true);
})();
  } catch(e) { console.error(e); }
})();

})();
